function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "zipIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 919",
  transform: "translate(865 418)",
  fill: "#fff",
  stroke: "#707070",
  d: "M0 0h40v40H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-865 -418)",
  clipPath: "url(#zipIcon_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1057",
  fill: "#bebebe"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Subtraction 32",
  d: "M901.501 458h-33v-40h25.961l7.039 7v33z",
  opacity: 0.446
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Union 46",
  d: "M886.501 438h-4v-4.516h4V438zm-3.334-.694h2.669v-1.391h-2.669zm-.666-4.468v-1.29h2v1.29zm2-1.29v-1.935h2v1.936zm-2-1.935v-1.935h2v1.935zm2-1.936v-1.935h2v1.935zm-2-1.935v-1.936h2v1.936zm2-1.936v-1.935h2v1.935zm-2-1.935v-1.936h2V418h2v1.936h-2v1.935z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5242",
  d: "M901.446 425h-7v-7z",
  opacity: 0.446
})));

function SvgZipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2);
}

export default SvgZipIcon;